export const EXCEPTION_TYPES = [
    {
        id: 0,
        name: "Proveedores con excepcion",
        description: "",
    },
]